export default __webpack_public_path__ + "static/media/dds5168_4p-5.77da55a1.png";